import React from "react";
import { InstagramEmbed } from "react-social-media-embed";
import { useApp } from "../../contexts/AppContext";
import AvatarContainer from "../Avatar";

const PartnerDetails: React.FC = () => {
  const { coverage } = useApp();

  if (!coverage) {
    return null;
  }

  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        backgroundColor: "white",
        overflowX: "hidden",
        fontFamily: '"Plus Jakarta Sans", "Noto Sans", sans-serif',
      }}
    >
      {/* Header - Bio (Centralizado) */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "16px",
          paddingBottom: "10px",
          backgroundColor: "white",
        }}
      >
        <h2
          style={{
            color: "#111418",
            fontSize: "18px",
            fontWeight: "bold",
            textAlign: "center",
            letterSpacing: "-0.015em",
          }}
        >
          Bio
        </h2>
      </div>

      {/* Conteúdo principal */}
      <div style={{ padding: "16px" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "16px", alignItems: "flex-start" }}>
          {/* Avatar e Nome do Afiliado (Alinhado à Esquerda) */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", marginBottom: "16px" }}>
            <AvatarContainer avatar={coverage.profile.avatar}/>
          </div>

          {/* Descrição e Bio (Alinhado à Esquerda) */}
          <div style={{ textAlign: "left" }}>
            <p
              style={{
                color: "#637588",
                textAlign: "left",
                marginBottom: "8px",
              }}
            >
              {coverage.profile.name}.
            </p>
            {coverage.profile.bio.map((line: string, index: number) => (
              <p key={index} style={{ color: "#111418", fontSize: "14px", lineHeight: "1.5" }}>
                {line.split("**").map((segment, segmentIndex) =>
                  segmentIndex % 2 === 1 ? (
                    <strong key={segmentIndex}>{segment}</strong>
                  ) : (
                    segment
                  )
                )}
              </p>
            ))}
          </div>
        </div>
      </div>

      {/* Seção de Feed */}
      <h2
        style={{
          color: "#111418",
          fontSize: "22px",
          fontWeight: "bold",
          letterSpacing: "-0.015em",
          paddingLeft: "16px",
          paddingRight: "16px",
          paddingBottom: "12px",
          paddingTop: "20px",
        }}
      >
        Feed
      </h2>
      <div style={{ display: "flex", overflowY: "auto", padding: "16px", gap: "12px" }}>
        {coverage.profile.highlights?.map((highlight: any, index: number) => (
          <div key={index} style={{ display: "flex", justifyContent: "center" }}>
            <InstagramEmbed url={highlight.url} width={328}/>
          </div>
        ))}
      </div>

      {/* Seção de Verificação do Parceiro */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "16px",
          backgroundColor: "white",
          padding: "16px",
          minHeight: "72px",
        }}
      >
        {/* Ícone de Check */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "8px",
            backgroundColor: "#d8d8d8",
            width: "48px",
            height: "48px",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            height="24px"
            color="#131e48"
            fill="currentColor"
            viewBox="0 0 256 256"
          >
            <path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"></path>
          </svg>
        </div>

        {/* Detalhes do Parceiro */}
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
          <p style={{ color: "#111418", fontSize: "16px", marginBottom: "4px" }}>
            {coverage.profile.partnerDetails.verifiedStatus}
          </p>
          <p style={{ color: "#637588", fontSize: "14px" }}>
            {coverage.profile.partnerDetails.partnership}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PartnerDetails;
